import {configureStore} from '@reduxjs/toolkit'
import accountsReducer from './account'

export const store = configureStore({
    reducer: {
        accounts : accountsReducer
    },
})
